import React from 'react';

import Framework from "@beardeddevops/react.framework"
import {Objects} from "components";

import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import moment from "moment";
import ReactTable from "react-table";
import RightArrowIcon from "@material-ui/icons/ChevronRight";
import ExpandMore from "@material-ui/icons/ExpandMore";

const breadcrumbsStatic = [{
	name: 'Dispatch',
	url: '/dispatch',
	icon: 'dashboard',
}];

export default class OptimizeRoutes extends Framework.Components.View {

	constructor(props) {
		super(props);
		const params = props.location.search?.split('?')[1]?.split('&') ?? [];
		let date = moment().format();
		let region = null;
		if (params.length > 0) {
			date = params[0].split('=')[1]
			region = params[1].split('=')[1]
		}
		this.state = {
			filterDate: date,
			fePkeys: [],
			mileage: [],
			showLegend: true,
			region: region
		};
	}

	updateRegion = (region, name) => {
		this.setState({region, name})
	}

	updateGivenAddress = (lat, lng) => {
		this.setState({selectedAddress: {lat: lat, lng: lng}});
	}

	updateFilterDate = (date) => {
		this.setState({filterDate: moment(date).format('YYYY-MM-DD')})
	}

	setAddress = ([lat, lng, region]) => {
		this.setState({selectedAddress: {lat: lat, lng: lng}, filterRegion: region})
	}

	render() {
		const columns = [
			{
				Header: "Field Engineer",
				id: "name",
				accessor: (obj) => obj.name
			},
			{
				Header: "Last Scheduled Location",
				id: "last_location",
				accessor: obj => (obj.lastLatitude + ", " + obj.lastLongitude)
			},
			{
				Header: "Mileage",
				id: "miles",
				accessor: obj => obj.miles,
			}
		];

		let {match, history} = this.props;

		let breadcrumbs = breadcrumbsStatic.concat([
			{
				name: 'Optimize Routes',
				url: `/mapped`,
				icon: 'maps',
			}
		]);

		return (
			<div className="container-fluid">

				<Framework.Components.PageBar breadcrumbs={breadcrumbs} history={history}/>

				<Card>
					<CardContent>
						<div className={'row'}>
							<div className={'col-4'}>
								<div className={'row'}>
									<div className={'col-12'}>
										<h4 className="section-title">
											<div className={'row'}>
												<div className={'col-10'}>
													Map Icon Legend
												</div>
												<div className={'col-2 flex-end text-right'}>
													<button onClick={() => this.setState({showLegend: !this.state.showLegend})}>
														{this.state.showLegend ? <ExpandMore/> : <RightArrowIcon/>}
													</button>
												</div>
											</div>
										</h4>
										{this.state.showLegend &&
											<Card>
												<ul style={{display: "block", listStyleType: 'none'}}>
													<li>
														<svg height={30} width={30}>
															<path
																d="M 1.1111 10.35 V 26.592 H 9.9701 V 16.2563 H 18.8299 V 26.592 H 27.6889 V 10.35 L 14.4 0.0139 Z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: FE Home
														</span>
													</li>
													<li>
														<svg height={30} width={30}>
															<path d="M 14.5 22.5 z m 0 1.5 A 12 12 90 1 0 14.5 0 a 12 12 90 0 0 0 24 Z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: First Appointment
														</span>
													</li>
													<li>
														<svg height={30} width={30}>
															<path
																d="M 15 1.875 h 1.875 v 11.25 h 11.25 v 3.75 h -11.25 v 11.25 h -3.75 v -11.25 h -11.25 v -3.75 h 11.25 v -11.25 z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: Second Appointment
														</span>
													</li>
													<li>
														<svg height={30} width={30}>
															<path
																d="M 14.8861 2.8294 A 0.2389 0.2389 90 0 1 15.0037 2.8 a 0.2389 0.2389 90 0 1 0.1162 0.0294 a 0.2683 0.2683 90 0 1 0.0992 0.1052 l 12.6002 21.4377 c 0.0662 0.1103 0.0648 0.2279 0.0037 0.3358 a 0.2999 0.2999 90 0 1 -0.0992 0.1103 a 0.2131 0.2131 90 0 1 -0.1213 0.0317 H 2.4058 a 0.2117 0.2117 90 0 1 -0.1213 -0.0317 a 0.2999 0.2999 90 0 1 -0.0992 -0.1103 a 0.3234 0.3234 90 0 1 0.0037 -0.3358 L 14.7869 2.9346 a 0.2697 0.2697 90 0 1 0.0992 -0.1052 Z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: Third Appointment
														</span>
													</li>
													<li>
														<svg height={30} width={30}>
															<path
																d="M 2.5 2.5 L 22.5 2.5 L 22.5 22.5 L 2.5 22.5 z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: Fourth Appointment
														</span>
													</li>
													<li>
														<svg height={30} width={30}>
															<path
																d="M 6.3575 23.0394 c -0.1185 0.6743 0.5467 1.2016 1.133 0.9003 l 6.6673 -3.4263 l 6.6661 3.4263 c 0.5862 0.3007 1.2515 -0.226 1.133 -0.8991 l -1.2606 -7.1837 l 5.349 -5.0969 c 0.5012 -0.4769 0.243 -1.3487 -0.4283 -1.4428 l -7.4388 -1.057 L 14.8613 1.6889 a 0.7794 0.7794 90 0 0 -1.4082 0 L 10.1361 8.262 l -7.4388 1.057 c -0.6701 0.0942 -0.9295 0.9659 -0.4295 1.4428 l 5.3509 5.0969 l -1.2606 7.1837 z"/>
														</svg>
														<span style={{
															fontSize: '20px',
															lineHeight: '12px',
															display: 'inline-block',
															fontWeight: 'bold'
														}}>: Any after four appointments
														</span>
													</li>
												</ul>
											</Card>}
									</div>

									<div className={"col-12"} style={{display: "flex", fontSize: 20, justifyContent: "center"}}>
										<Objects.ScheduleFieldEngineer
											history={history}
											location={this.state.region}
											updateFilterDate={this.updateFilterDate}
											userColors={this.state.userColors}
											allFes={true}
											getMileage={(mileage) => {
												let data = Object.keys(mileage).map((key) => mileage[key]);
												this.setState({mileage: data})
											}}
											defaultDate={this.state.filterDate}
											isSaving={false}
											shouldLoadInitial={true}
											selectedAddress={this.state.selectedAddress ?? null}
										/>
									</div>
								</div>
								<Objects.CustomerLocation
									history={this.props.history}
									hasModal={true}
									updateRegion={this.updateRegion}
									updateGivenAddress={this.updateGivenAddress}
									setAddress={this.setAddress}
									defaultRegion={this.state.region}
								/>
							</div>
							<div className={'col-8'}>
								<Objects.DispatchMap
									filterRegion={this.state.region}
									filterDate={this.state.filterDate}
									selectedAddress={this.state.selectedAddress ?? null}
									setColors={(userColors) => {
										this.setState({userColors})
									}}
									setRegion={(region) => {
										this.setState({region, selectedAddress: null})
									}}
									noSubmit={true}
									popularRegions={true}
									noCycle={false}
								/>
							</div>
						</div>

						<hr/>

						<ReactTable
							columns={columns}
							manual
							data={this.state.mileage}
							expanderDefaults={{
								sortable: true,
								resizable: false,
								filterable: true,
								width: undefined
							}}
							className='-striped -highlight'
							defaultPageSize={this.state.mileage.length}
							showPagination={false}
						/>

					</CardContent>
				</Card>

			</div>
		)
	}
};
